import React from 'react';

import 'Assets/styles/default/pages/concierge/NewConciergeSolicitationStyles.less';

import { Col, Row } from 'antd';

import {
  VertModal,
  VertContainer,
  VertButton,
  Typography,
  notification,
} from '@vertem-core/vertice-ds';

import Warning from 'components/Concierge/Icons/warning';

const DeleteConciergeItemModal = ({ isOpen, onClose, deleteItem }) => {
  const handleConciergeItemDelete = () => {
    deleteItem();
    onClose();

    notification.success({
      message: "Produto/serviço removido com sucesso."
    });
  }

  return (
    <VertModal
      destroyOnClose={false}
      closable={false}
      open={isOpen}
      onCancel={onClose}
      className="delete-concierge-item-modal"
    >
      <Warning className="margin-bottom-divider" />

      <VertContainer className="text-weight-modal-confirmation margin-bottom-divider margin-top-divider">
        <Typography.Title level={2} className='color-title' >
          Você deseja excluir este produto/serviço da sua solicitação?
        </Typography.Title>
      </VertContainer>

      <Row className='margin-top-divider' justify={"center"}>
        <Col>
          <VertButton
            className='button-cancel-continue button-concierge'
            type='default'
            size="default"
            onClick={() => onClose()}
          >
            Cancelar
          </VertButton>
        </Col>
        <Col>
          <VertButton
            className='button-cancel-continue button-concierge'
            type='highlight'
            size="default"
            onClick={handleConciergeItemDelete}
          >
            Confirmar
          </VertButton>
        </Col>
      </Row>
    </VertModal>
  );
};

export default DeleteConciergeItemModal;
